<template>
    <v-container>
        <v-row>
            <v-col>
                <v-row>
                    <v-col></v-col>
                    <v-col cols="auto">
                        <v-btn icon
                               :color="color"
                               :disabled="selection === 'all' || readonly"
                               @click="selectAll">
                            <v-icon>mdi-select-all</v-icon>
                        </v-btn>
                        <v-btn icon
                               :color="color"
                               :disabled="selection === 'none' || readonly"
                               @click="deselectAll">
                            <v-icon>mdi-select-off</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-list>
                    <v-list-item-group v-model="selectedItems"
                                       :color="color"
                                       itemid="id"
                                       multiple>
                        <v-list-item v-for="item in items" :key="item.id"
                                     :disabled="readonly">
                            <template v-slot:default="{active}">


                                <v-card v-if="item.id === 'channel_api'" style=""
                                        :class="{'error-border':typeError}"
                                        outlined
                                        width="50">
                                    <v-select :items="notificationTypes"
                                              :value="type"
                                              @click.stop=""
                                              @change="$emit('change:type', $event)"
                                              label="Icon"
                                              hide-details
                                              class="ma-0 pa-0"
                                              dense
                                              item-value="type">
                                        <template v-slot:item="{item}">
                                            <v-icon>{{ item.icon }}</v-icon>
                                        </template>
                                        <template v-slot:selection="{item}">
                                            <v-icon small>{{ item.icon }}</v-icon>
                                        </template>
                                    </v-select>
                                </v-card>

                                <v-icon v-else small class="mr-2">{{ item.icon }}</v-icon>

                                {{ item.name }}
                                <v-spacer/>
                                <v-list-item-icon>
                                    <v-icon small v-show="active">mdi-check</v-icon>
                                </v-list-item-icon>
                            </template>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import notificationTypes from "../../../utils/notificationTypes";

export default {
    name: "NotificationChannels",
    props: {
        color: {
            type: String,
            default: "primary"
        },
        readonly: {
            type: Boolean,
            default: false
        },
        campaign: {},
        type: {},
        typeError: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'change',
        'changeType'
    ],
    model: {
        event: 'change',
        prop: 'campaign'
    },
    data() {
        return {
            items: [
                {id: 'channel_api', name: 'In App Benachrichtigung', icon: 'mdi-cellphone-text'},
                {id: 'channel_apn', name: 'Apple Push Benachrichtigung', icon: 'mdi-apple'},
                {id: 'channel_android', name: 'Android Push Benachrichtigung', icon: 'mdi-android'},
            ],
        };
    },
    computed: {
        selectedItems: {
            get() {
                return this.items.map((item, index) => this.campaign[item.id] ? index : null)
                    .filter(index => index !== null);
            },
            set(value) {
                this.updateSelectedChannels(value);
            }
        },
        selection() {
            if (this.selectedItems.length === this.items.length) {
                return "all";
            } else if (this.selectedItems.length === 0) {
                return "none";
            } else {
                return "partial";
            }
        },
        notificationTypes() {
            return Object.keys(notificationTypes).map(type => {
                return {type, icon: notificationTypes[type]};
            })
        },
    },
    methods: {
        selectAll() {
            this.selectedItems = this.items.map((_, index) => index);
        },
        deselectAll() {
            this.selectedItems = [];
        },
        updateSelectedChannels(items) {
            let selectedChannels = [];
            selectedChannels = items.filter(itemIndex => itemIndex < this.items.length)
                .map(itemIndex => this.items[itemIndex].id);
            this.$emit('change', selectedChannels);
        }
    }
}
</script>

<style scoped>
.error-border {
    border-color: #e9605c
}
</style>
